export const ACTIVE_RECIPE_KEY = 'active_recipe';
export const SAVED_RECIPES_KEY = 'saved_recipes';
